import { useCallback, useState } from "react";
import { useLocale, useService } from "../../../../hooks";

export const useSubscriptionForm = () => {
  const { t } = useLocale();
  const [value, setvalue] = useState<string>("");
  const { isValidEmail } = useService("Validation");
  const { save } = useService("Data", "franchise");
  const { parseValue, getFranchiseRequest, generateUID, showAlert } =
    useService("Misc");
  const subscribeForFranchise = useCallback(
    async (e) => {
      e.preventDefault();
      let error = false,
        errorMsg = "",
        franchiseObject = {
          name: parseValue(),
          pinCode: parseValue(),
          email: parseValue(value),
          mobile: parseValue(),
          message: parseValue(),
          city: parseValue(),
          uid: generateUID(),
          status: "raised",
        };
      if (value === "") {
        errorMsg = t("errorMsg.required.email");
        error = true;
      } else if (!isValidEmail(value)) {
        errorMsg = t("errorMsg.validate.email");
        error = true;
      }
      if (!error) {
        await save(franchiseObject);
        const result = await getFranchiseRequest(franchiseObject);
        if (result.status) {
          showAlert({
            type: "info",
            msg: t("success.franchiseRequestSubmitted"),
          });
          setvalue("");
        } else
          showAlert({
            type: "error",
            msg: t("errorMsg.fail.franchiseRequestSubmitted"),
          });
      } else showAlert({ type: "error", msg: errorMsg });
    },
    [
      generateUID,
      getFranchiseRequest,
      isValidEmail,
      parseValue,
      save,
      showAlert,
      t,
      value,
    ]
  );
  return {
    value,
    setvalue,
    subscribeForFranchise,
  };
};
